module.exports = __webpack_public_path__ + "img/ESCUCHARLO.00b58ba0.png";